import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/holy-loader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ViewTransitions"] */ "/vercel/path0/node_modules/next-view-transitions/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["usePageTrackerStore"] */ "/vercel/path0/node_modules/react-page-tracker/dist/page-tracker-store.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageTracker"] */ "/vercel/path0/node_modules/react-page-tracker/dist/page-tracker.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorToast"] */ "/vercel/path0/src/components/primitives/error-toast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitals"] */ "/vercel/path0/src/components/primitives/web-vitals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WavesBackground"] */ "/vercel/path0/src/components/ui/background-waves.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextHighlighter"] */ "/vercel/path0/src/components/ui/fancy/text-highlighter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/vercel/path0/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCReactProvider"] */ "/vercel/path0/src/lib/trpc/react.tsx");
